import { SidebarIcon, Book } from "lucide-react"

import { SearchForm } from "./search-form"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { useSidebar } from "@/components/ui/sidebar"
import { ThemeToggle } from "./ThemeToggle"
import { useAppDispatch, useAppSelector } from "@/store/hooks"
import { openGlossaryModal } from "@/store/slices/glossarySlice"

export function SiteHeader() {
  const { toggleSidebar } = useSidebar()
  const dispatch = useAppDispatch()
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  
  const handleGlossaryClick = () => {
    dispatch(openGlossaryModal())
  }

  return (
    <header className="flex sticky top-0 z-50 w-full items-center border-b bg-background">
      <div className="flex h-[--header-height] w-full items-center gap-2 px-4">
        <Button
          className="h-8 w-8"
          variant="ghost"
          size="icon"
          onClick={toggleSidebar}
        >
          <SidebarIcon />
        </Button>
        <Separator orientation="vertical" className="mr-2 h-4" />
        {/* <Breadcrumb className="hidden sm:block">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="#">
                Building Your Application
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>Data Fetching</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb> */}
        <SearchForm className="w-full sm:ml-auto sm:w-auto" />
        
        {/* Glossary button - show for authenticated users */}
        {isAuthenticated && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleGlossaryClick}
            className="h-8 gap-2"
            title="Open Glossary (Cmd/Ctrl+K)"
          >
            <Book className="h-4 w-4" />
            <span className="hidden sm:inline">Glossary</span>
            <span className="hidden lg:inline text-xs opacity-60">⌘K</span>
          </Button>
        )}
        
        <ThemeToggle variant="dropdown" />

      </div>
    </header>
  )
}
